import * as React from 'react';
import { ComplexValue, ValidationProps, createValidationErrors } from 'ui';

interface PrimaryOwnerPanelState {
  primaryOwner?: ComplexValue<number>;
  primaryOwnerQuery?: string;
  primaryOwnerError?: boolean;
}

interface PrimaryOwnerPanelTranslation {
  must_be_filled: string;
  primary_owner: string;
  primary_owner_info_message: string;
  search_placeholder: string;
}

interface PrimaryOwnerPanelHandlers {
  onPrimaryOwnerChange: (value: ComplexValue<number>) => void;
  onPrimaryOwnerLoadOptions: (params: { query: string }) => void;
}

export const getInitialScheduleOwners = (
  updateReport: boolean,
  initialOwners: ComplexValue<number>[]
): ComplexValue<number>[] | undefined => updateReport ? undefined : initialOwners;

export const buildScheduleReportPanelProps = (
  initialOwners: ComplexValue<number>[],
  owners: ComplexValue<number>[],
  state: PrimaryOwnerPanelState,
  translation: PrimaryOwnerPanelTranslation,
  handlers: PrimaryOwnerPanelHandlers
) => ({
  initialOwners,
  owners,
  primaryOwner: state.primaryOwner,
  primaryOwnerQuery: state.primaryOwnerQuery,
  primaryOwnerValidation: state.primaryOwnerError
    ? createValidationErrors([translation.must_be_filled]) as ValidationProps
    : undefined,
  primaryOwnerLabel: translation.primary_owner,
  primaryOwnerInfoMessage: translation.primary_owner_info_message,
  primaryOwnerPlaceholder: translation.search_placeholder,
  onPrimaryOwnerChange: handlers.onPrimaryOwnerChange,
  onPrimaryOwnerLoadOptions: handlers.onPrimaryOwnerLoadOptions
});

export const renderScheduleReportPanel = (
  scheduleReportPanel: React.ReactNode,
  extraProps: Record<string, unknown>
) => React.isValidElement(scheduleReportPanel)
  && React.cloneElement(scheduleReportPanel as React.ReactElement<Record<string, unknown>>, extraProps);
